<template>
  <location-table :company-id="companyId" hide-upload class="mt-3" />
</template>
<script>
import LocationTable from '@/components/shipment_md/LocationTable.vue';

export default {
  name: 'customer_location_list',
  components: {
    LocationTable,
  },
  computed: {
    companyId() {
      return this.$route.params.companyId;
    },
  },
  created() {
    this.$store.dispatch('customers/LOAD_DETAIL_DATA');
  },
};
</script>




// WEBPACK FOOTER //
// src/views/pages/shipment_md/customers/detail/Locations.vue